import React, { useContext, useEffect, useState } from 'react';

import './voucher.css';
import { INSTANCE_WHITE_LOGO_URL as logo } from '../../components/ui/InstanceLogo';
import { InvoiceContext } from '../../context/invoice/InvoiceContext';

const VoucherPage: React.FC = () => {
  const [logoUrl, setLogoUrl] = useState<string | null>(null);
  const { merchant, transaction, invoice, order, isLoading, loadInvoice } = useContext(InvoiceContext);

  const [currency, setCurrency] = useState<string>("188");

  useEffect(() => {
    const token = getTokenFromUrl(window.location.href);
    if (token) {
      setTimeout(() => loadInvoice(token), 1000);
    }
  }, []);

  useEffect(() => {
    if (invoice != null && invoice.currencyId != null) {
      setCurrency(invoice.currencyId.toString());
    }

  }, [invoice]);



  const getTokenFromUrl = (url: string): string | null => {
    const parts = url.split('/');
    return parts.length > 0 ? parts[parts.length - 1] : null;
  };

  const getStatus = (status) => {
    switch (status) {
      case "APPROVED":
        return 'Aprobado';
      case "REFUND":
        return 'Devolución';
      case "VOID":
        return 'Anulación';
      case "DECLINED":
        return 'Rechazada';
      default:
        return '';
    }
  }

  const getFormatAmount = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }

  useEffect(() => {
    setLogoUrl(logo);
  }, []);

  return (
    <div>
      {isLoading ? (
        <div className="d-flex justify-content-center">
          <div className="spinner-border text-info mt-5" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) :
        merchant == null ?
          (
            <div className="wrapper1">
              <div className="headerLogin">
                <img src={logoUrl || ''} alt="Logo" className="logo" />
              </div>
              <div className="container-voucher my-5">
                <p>Ocurrió un error procesando la solicitud</p>
              </div>
            </div>
          )
          :
          (
            <div className="wrapper1">
              <div className="headerLogin">
                <img src={logoUrl || ''} alt="Logo" className="logo" />
              </div>
              <div className="container-voucher my-5">

                <div className="row">
                  <div className="col-md-10 mx-auto">
                    <div>

                      {/* Información de la Empresa */}
                      <div className="mb-4" style={{ 'marginTop': '15px' }}>
                        <h4 className='text-center'>{merchant.name}</h4>
                        {
                          merchant.phone ? <p>Teléfono: {merchant.phone}</p> : ''
                        }
                        {
                          merchant.email ? <p>Correo: {merchant.email}</p> : ''
                        }
                        <p>Dirección: {merchant.address}</p>
                      </div>

                      {/* Detalles de la Transacción */}
                      <h5 className="mb-3 text-center">Detalles de la Transacción</h5>
                      <div className="row mb-2">
                        <div className="col-4 fw-bold">Estado:</div>
                        <div className="col-8 fw-bold" style={{ 'textAlign': 'right', color: 'var(--primary-color)' }}>{getStatus(transaction.status).toUpperCase()}</div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-4 fw-bold">Fecha:</div>
                        <div className="col-8" style={{ 'textAlign': 'right' }}>{new Date(transaction.date_time).toLocaleString()}</div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-4 fw-bold">Monto:</div>
                        <div className="col-8" style={{ 'textAlign': 'right' }}>{getFormatAmount(transaction.amount / 100) + " " + transaction.currency_code}</div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-4 fw-bold">Esquema:</div>
                        <div className="col-8" style={{ 'textAlign': 'right' }}> {transaction.scheme.charAt(0).toUpperCase() + transaction.scheme.slice(1).toLowerCase()}</div>
                      </div>

                      {
                        transaction.scheme && transaction.scheme.toLowerCase() === 'tarjeta' ?
                          (
                            <>
                              <div className="row mb-2" >
                                <div className="col-4 fw-bold">Tarjeta:</div>
                                <div className="col-8" style={{ 'textAlign': 'right' }}>{transaction.pan}</div>
                              </div>
                              <div className="row mb-2">
                                <div className="col-4 fw-bold">Autorización:</div>
                                <div className="col-8" style={{ 'textAlign': 'right' }}>{transaction.auth_code}</div>
                              </div>
                              <div className="row mb-2">
                                <div className="col-4 fw-bold">Referencia:</div>
                                <div className="col-8" style={{ 'textAlign': 'right' }}>{transaction.external_transaction_reference}</div>
                              </div>
                            </>
                          ) : null
                      }




                      {/* Detalles de la Factura */}
                      <h5 className="mt-5 mb-3 text-center">Detalles de la Factura</h5>
                      <p>
                        <strong>Número de Factura:</strong> {invoice.invoiceNumber}
                      </p>
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead className="bg-secondary text-white">
                            <tr>
                              <th>Producto</th>
                              <th>Cantidad</th>
                              <th style={{ 'textAlign': 'right' }}>Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            {order.products.map((product) => (
                              <tr key={product.id}>
                                <td style={{ 'width': '370px' }}>{product.name}</td>
                                <td>{product.quantity}</td>
                                <td style={{ 'textAlign': 'right' }}>{getFormatAmount((product.customPrice ? product.customPrice : product.price))}</td>
                              </tr>
                            ))}

                          </tbody>
                        </table>
                      </div>
                      <table style={{ 'width': '100%' }}>
                        <tr>
                          <th colSpan={3} style={{ 'textAlign': 'right' }}>Subtotal:</th>
                          <td style={{ 'textAlign': 'right' }}><strong>{getFormatAmount(currency == "188" ? invoice.localSubtotal : invoice.dollarSubtotal)}</strong></td>
                        </tr>
                        <tr>
                          <th colSpan={3} style={{ 'textAlign': 'right' }}>IVA:</th>
                          <td style={{ 'textAlign': 'right' }}><strong>{getFormatAmount(currency == "188" ? invoice.localSalesTax : invoice.dollarSalesTax)}</strong></td>
                        </tr>
                        <tr>
                          <th colSpan={3} style={{ 'textAlign': 'right' }}>Otros cargos:</th>
                          <td style={{ 'textAlign': 'right' }}><strong>{getFormatAmount(currency == "188" ? invoice.localOtherChagerAmount : invoice.dollarOtherChagerAmount)}</strong></td>
                        </tr>
                        <tr>
                          <th colSpan={3} style={{ 'textAlign': 'right' }}>
                            Total:
                          </th>
                          <td style={{ 'textAlign': 'right' }}>
                            <strong>{getFormatAmount(currency == "188" ? invoice.localTotal : invoice.dollarTotal)}</strong>
                          </td>
                        </tr>
                      </table>
                    </div>

                    <div className="text-center mt-5">
                      <p>Gracias por su compra</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
    </div>
  );
};

export default VoucherPage;
